export default {
    methods: {
        //모바일 일 때 true 를 리턴 함.
        isMobile() {
            //return this.$vuetify.breakpoint.mobile            
            return this.$vuetify.breakpoint.xsOnly
        },
    },
}